import { Courses } from "../courses"

export const SalesLearnings = ({pageSwap, courseToUpdate, setCourseToUpdate, AiStarted }) => {
    return(
        <Courses
            titleScreen = "Sales learnings"
            CustomerStage = {1}
            pageSwap={pageSwap}
            courseToUpdate={courseToUpdate}
            setCourseToUpdate={setCourseToUpdate}
            AiStarted={AiStarted}
            
        />
    )
}